import React from "react";

const AppContext = React.createContext();
AppContext.displayName = "AppContext";

export default AppContext;
